module.exports = __webpack_public_path__ + "assets/images/image.a8b13fe2dce0a50d81351a4208e84f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/getting-started/image.png
// module id = 1066
// module chunks = 0